import {
  VUEX_TOAST_SHOW,
  VUEX_TOAST_HIDE,

  VUEX_TOAST_ADD,

  VUEX_TOAST_REMOVE,

  VUEX_TOAST_CLEAR_ALL,
  VUEX_TOAST_CLEAR_ALL_PERSISTENT
} from '@/store/constants/ui/toast'


/* // Example Toast
  {
    component: '_core/Toast/Toast_Message.vue',
    persist: true,
    data: {
      type: 'success', // 'success', 'error', 'warning'
      message: 'My message here',
    },
    closeCallback: () => {
      alert('You clicked the close button')
    }
  }
*/

const state = {
  currentToasts: []
}

const getters = {
  numberOfNotifications: state => state.currentToasts.length
}

const actions = {
  [VUEX_TOAST_SHOW]: ({ commit }, payload) => {
    const toast = {
      ...payload,
      id: Date.now(),
      open: true
    }

    commit(VUEX_TOAST_ADD, toast)

    if (!toast.persist) {
      setTimeout(() => {
        commit(VUEX_TOAST_REMOVE, toast.id)
      }, toast.timeout || ITS__UI__TOAST__DELAY__DEFAULT)
    }
  },

  [VUEX_TOAST_HIDE]: ({ commit }, id) => {
    commit(VUEX_TOAST_REMOVE, id)
  },

  [VUEX_TOAST_CLEAR_ALL]: ({ commit }) => {
    commit(VUEX_TOAST_CLEAR_ALL)
  },

  [VUEX_TOAST_CLEAR_ALL_PERSISTENT]: ({ commit }) => {
    commit(VUEX_TOAST_CLEAR_ALL_PERSISTENT)
  }
}

const mutations = {
  [VUEX_TOAST_ADD]: (state, data) => {
    state.currentToasts.push(data)
  },

  [VUEX_TOAST_REMOVE]: (state, id) => {
    state.currentToasts = state.currentToasts.filter(t => t.id !== id)
  },

  [VUEX_TOAST_CLEAR_ALL]: (state) => {
    state.currentToasts = []
  },

  [VUEX_TOAST_CLEAR_ALL_PERSISTENT]: (state) => {
    state.currentToasts = state.currentToasts.filter(t => !t.persist)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
